export const FEEDBACK_MODAL = {
  TITLE: 'Fintel Check Feedback',
  CONFIMRATION: 'Do you consider this status to be correct?',
  CORRECTION: 'What should the status be?',
  CANCEL: 'Cancel',
  SUBMIT: 'Submit',
};
